/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityDataleaksResultEvidence } from './MonitEntityDataleaksResultEvidence';
import {
    MonitEntityDataleaksResultEvidenceFromJSON,
    MonitEntityDataleaksResultEvidenceFromJSONTyped,
    MonitEntityDataleaksResultEvidenceToJSON,
} from './MonitEntityDataleaksResultEvidence';

/**
 * 
 * @export
 * @interface MonitEntityDataleaksCountResponse
 */
export interface MonitEntityDataleaksCountResponse {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityDataleaksCountResponse
     */
    user: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityDataleaksCountResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityDataleaksCountResponse
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityDataleaksCountResponse
     */
    source_asset: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityDataleaksCountResponse
     */
    fullname: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitEntityDataleaksCountResponse
     */
    features: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityDataleaksCountResponse
     */
    year: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityDataleaksCountResponse
     */
    date: number;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityDataleaksCountResponse
     */
    severity: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityDataleaksCountResponse
     */
    target_hostname: string;
    /**
     * 
     * @type {MonitEntityDataleaksResultEvidence}
     * @memberof MonitEntityDataleaksCountResponse
     */
    evidences: MonitEntityDataleaksResultEvidence;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityDataleaksCountResponse
     */
    count?: number;
}

/**
 * Check if a given object implements the MonitEntityDataleaksCountResponse interface.
 */
export function instanceOfMonitEntityDataleaksCountResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "domain" in value;
    isInstance = isInstance && "source_asset" in value;
    isInstance = isInstance && "fullname" in value;
    isInstance = isInstance && "features" in value;
    isInstance = isInstance && "year" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "severity" in value;
    isInstance = isInstance && "target_hostname" in value;
    isInstance = isInstance && "evidences" in value;

    return isInstance;
}

export function MonitEntityDataleaksCountResponseFromJSON(json: any): MonitEntityDataleaksCountResponse {
    return MonitEntityDataleaksCountResponseFromJSONTyped(json, false);
}

export function MonitEntityDataleaksCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityDataleaksCountResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': json['user'],
        'name': json['name'],
        'domain': json['domain'],
        'source_asset': json['source_asset'],
        'fullname': json['fullname'],
        'features': json['features'],
        'year': json['year'],
        'date': json['date'],
        'severity': json['severity'],
        'target_hostname': json['target_hostname'],
        'evidences': MonitEntityDataleaksResultEvidenceFromJSON(json['evidences']),
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function MonitEntityDataleaksCountResponseToJSON(value?: MonitEntityDataleaksCountResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': value.user,
        'name': value.name,
        'domain': value.domain,
        'source_asset': value.source_asset,
        'fullname': value.fullname,
        'features': value.features,
        'year': value.year,
        'date': value.date,
        'severity': value.severity,
        'target_hostname': value.target_hostname,
        'evidences': MonitEntityDataleaksResultEvidenceToJSON(value.evidences),
        'count': value.count,
    };
}

